import $ from 'jquery';

$(function () {
  const $map = $('#single-event-map');

  if (!$map.length) {
    return;
  }

  const googleMapsAPI = 'https://maps.googleapis.com/maps/api/';
  const googleAPIKey = 'AIzaSyDiUg2Y4cK2hvqx2EUf2n8GtKhRsaxa-2s';
  const address = $map.data('address');

  // Attach the callback before the API script loads.
  window.initMap = function () {
    // Geocode with the JS API's Geocoder rather than the REST web service.
    // The API key is HTTP-referrer restricted, and referrer-restricted keys
    // are rejected by the REST Geocoding endpoint. The in-browser Geocoder
    // sends a referer, so the same key works here.
    const geocoder = new google.maps.Geocoder();

    geocoder.geocode({ address: address }, function (results, status) {
      if (status !== 'OK' || !results || !results[0]) {
        // eslint-disable-next-line no-console
        console.error('Geocode failed for event address:', status);
        return;
      }

      const coordinates = results[0].geometry.location;

      const map = new google.maps.Map(
        document.getElementById('single-event-map'),
        {
          center: coordinates,
          zoom: 13
        }
      );

      new google.maps.Marker({
        position: coordinates,
        map: map
      });
    });
  };

  // Create the script tag, set the appropriate attributes.
  const script = document.createElement('script');
  script.src = `${googleMapsAPI}js?key=${googleAPIKey}&callback=initMap`;
  script.async = true;

  document.head.appendChild(script);
});
